import { Reducer } from 'redux';

import { ActionType } from '../../../store/actionTypes';
import {
  ActionWithPlayload,
  EntityAction,
  ErrorAction,
  isActionWithPayload,
} from '../../../store/types';

export interface AnalysisReportState {
  isFetching: boolean;
  error?: boolean;
}

export const initialState: AnalysisReportState = {
  isFetching: false,
};

type Action =
  | ActionWithPlayload<ActionType.FETCH_ANALYSIS_REPORT_STARTED>
  | EntityAction<ActionType.FETCH_ANALYSIS_REPORT_SUCCEEDED>
  | ErrorAction<ActionType.FETCH_ANALYSIS_REPORT_FAILED>;

export const analysisReportReducer: Reducer<AnalysisReportState, Action> = (
  state: AnalysisReportState = initialState,
  action: Action,
) => {
  if (isActionWithPayload(action)) {
    switch (action.type) {
      case ActionType.FETCH_ANALYSIS_REPORT_STARTED:
        return {
          ...state,
          isFetching: true,
          error: false,
        };
      case ActionType.FETCH_ANALYSIS_REPORT_SUCCEEDED:
        return {
          ...state,
          isFetching: false,
          error: false,
        };
      case ActionType.FETCH_ANALYSIS_REPORT_FAILED:
        return {
          ...state,
          isFetching: false,
          error: action.error,
        };
      default:
        return state;
    }
  }

  return state;
};

export default analysisReportReducer;
